import i18n from "@/i18ns/i18n.js";
export const SubSystemCode = {
  // Kết nối
  Connect: "Connect",
  //Tổng quan
  Dashboard: "Dashboard",
  //  Thiết lập mẫu email
  EmailTemplate: "EmailTemplate",
  // Đề xuất của tôi
  MyRequest: "MyRequest",
  // Đề xuất khác
  OtherRequest: "OtherRequest",
  // Mẫu in
  PrintTemplate: "PrintTemplate",
  // Báo cáo
  Report: "Report",
  // Thiết lập đề xuất
  RequestType: "RequestType",
  // Vai trò
  Role: "Role",
  // Người dùng
  User: "User",
  //Thiết lập
  Setting: "Config",
  // Tab Tra cứu
  Search: "Search",
  // Tab đề xuất
  Request: "Request",
  // thiết lập người dùng
  UserGroup: "UserGroup",
  // Tab báo cáo
  Report: "Report",
};
